import { i18n } from './index'
import { translatePageText } from './pageText'

export const translate = (key: string, named?: Record<string, unknown>): string => {
  return i18n.global.t(key, named || {}) as string
}

export const translateTitle = (title?: string, titleKey?: string): string => {
  if (titleKey) {
    return translate(titleKey)
  }
  if (title?.startsWith('route.')) {
    return translate(title)
  }
  return title || ''
}

export const translateRouteTitle = (routeOrMeta: any): string => {
  const meta = routeOrMeta?.meta || routeOrMeta || {}
  if (routeOrMeta?.path === '/dashboard') return translatePageText('概览')
  if (routeOrMeta?.path === '/institution') return translatePageText('机构')
  if (routeOrMeta?.path === '/course') return translatePageText('课程')
  if (routeOrMeta?.path === '/users-and-accounts' && !meta.menuIndex) {
    return translatePageText('账号')
  }
  // Keep the backend route and permissions intact; rename this course navigation group only.
  if (['officially', '/course/officially'].includes(routeOrMeta?.path) && meta.title === '官方提供') {
    return translatePageText('官方课程')
  }
  return translateTitle(meta.title, meta.titleKey)
}
